import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Spinner as o } from "../Spinner/index.js";
import { cn as c } from "../../utils/cn.js";
const f = ({
  children: r,
  isLoading: s,
  isFetching: i,
  className: t
}) => {
  const l = s || i;
  return /* @__PURE__ */ n(
    "div",
    {
      className: c(t, {
        "animate-pulse": l
      }),
      children: [
        l && /* @__PURE__ */ e("div", { className: "absolute rounded-2xl top-0 left-0 w-full h-full z-30", children: /* @__PURE__ */ e("div", { className: "flex items-center flex-col justify-center h-full max-h-screen", children: /* @__PURE__ */ e(o, { size: "xl" }) }) }),
        r
      ]
    }
  );
};
export {
  f as WithLoader
};
